import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useReducer,
} from "react";
import { axios } from "../../../../utils/useAxios";

const RequisitionBranchContext = createContext(null);

const initialState = {
  loading: false,
  team_list_loading: false,
  data: [],
  grid_summary: {
    total_code: 0,
    used_code: 0,
    unused_code: 0,
  },
  filters: {
    status: "",
    teamName: "",
    ownerPartnerCode: "",
    ownerName: "",
    userSearch: "",
    limit: 10,
    offset: 0,
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };

    case "SET_DATA":
      return {
        ...state,
        data: action.payload,
        grid_summary: action.payload?.sum,
      };
    case "SET_FILTERS":
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case "RESET_FILTERS":
      return {
        ...state,
        filters: initialState.filters,
      };

    default:
      return state;
  }
};

export const RequisitionBranchProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const fetchData = useCallback(async (params) => {
    dispatch({
      type: "SET_LOADING",
      payload: true,
    });

    try {
      const response = await axios.get("/healthy-me", {
        params,
      });
      dispatch({
        type: "SET_DATA",
        payload: response.data,
      });
    } catch (error) {
      console.error("Failed to fetch requisition data:", error);
    } finally {
      dispatch({
        type: "SET_LOADING",
        payload: false,
      });
    }
  }, []);
  const handleFilterChange = useCallback(
    (payload) => {
      const filters = { ...state.filters, ...payload, offset: 0 };
      dispatch({ type: "SET_FILTERS", payload: { ...payload, offset: 0 } });
      fetchData(filters);
    },
    [state.filters, fetchData],
  );
  const value = {
    state,
    dispatch,
    fetchData,
    handleFilterChange,
  };
  useEffect(() => {
    fetchData(initialState.filters);
  }, [fetchData]);
  return (
    <RequisitionBranchContext.Provider value={value}>
      {children}
    </RequisitionBranchContext.Provider>
  );
};

export const useRequisitionBranchContext = () => {
  const context = useContext(RequisitionBranchContext);

  if (!context) {
    throw new Error(
      "useRequisitionBranchContext must be used within RequisitionBranchProvider",
    );
  }

  return context;
};
